module.exports = __webpack_public_path__ + "img/ic_strategy_blue.0a9883ba.png";